import { ValidatorFn, FormGroup } from '@angular/forms'
import { formatDate } from '@angular/common'
import { HelperService } from "../services/helper.service"

export interface ICompareDates {
  dateStart?: string
  dateEnd: string
  comparator: string
  compareTime: boolean
}

export interface ICompareDatesDiff {
  dateStart: string
  dateEnd: string
  diff?: number|null
  diffCB?: () => number|null
}

export function datesComparator(
  dateStart: string,
  dateEnd: string,
  comparator: string,
  compareTime: boolean = false,
): ValidatorFn {
  return (formGroup: FormGroup<any>): { [key: string]: boolean } | null => {
    const startDate: any = formGroup.get(dateStart).value
    const endDate: any = formGroup.get(dateEnd).value

    if (startDate && endDate) {
      const format: string = compareTime ? 'MM/dd/yyyy HH:mm:ss' : 'MM/dd/yyyy'
      const d1: Date = new Date(formatDate(startDate, format, 'en'))
      const d2: Date = new Date(formatDate(endDate, format, 'en'))

      switch (true) {
        case comparator === '<':
          if (d1 < d2) {
            return { invalidDateInterval: true }
          }
          break
        case comparator === '<=':
          if (d1 <= d2) {
            return { invalidDateInterval: true }
          }
          break
        case comparator === '>':
          if (d1 > d2) {
            return { invalidDateInterval: true }
          }
          break
        case comparator === '>=':
          if (d1 >= d2) {
            return { invalidDateInterval: true }
          }
          break
        case comparator === '!==':
          if (d1 !== d2) {
            return { invalidDateInterval: true }
          }
          break
        case comparator === '==':
        case comparator === '===':
          if (d1 === d2) {
            return { invalidDateInterval: true }
          }
          break
      }
    }
    return null
  }
}

export function multiDatesComparator(groupOfDates: ICompareDates[]): ValidatorFn {
  return (formGroup: FormGroup<any>): { [key: string]: boolean } | null => {
    const validations: any = {}

    for (let k = 0; k < groupOfDates.length; k++) {
      const group: ICompareDates = groupOfDates[k]
      const invalidAttr: string = `invalidDateInterval_${k}`
      const startDate: any = group.dateStart
        ? formGroup.get(group.dateStart).value
        : new Date().toString()
      const endDate: any = formGroup.get(group.dateEnd).value

      if (startDate && endDate) {
        const format: string = group.compareTime ? 'MM/dd/yyyy HH:mm:ss' : 'MM/dd/yyyy'
        const d1: Date = new Date(formatDate(startDate, format, 'en'))
        const d2: Date = new Date(formatDate(endDate, format, 'en'))

        switch (true) {
          case group.comparator === '<':
            if (d1 < d2) {
              validations[invalidAttr] = true
            }
            break
          case group.comparator === '<=':
            if (d1 <= d2) {
              validations[invalidAttr] = true
            }
            break
          case group.comparator === '>':
            if (d1 > d2) {
              validations[invalidAttr] = true
            }
            break
          case group.comparator === '>=':
            if (d1 >= d2) {
              validations[invalidAttr] = true
            }
            break
          case group.comparator === '!==':
            if (d1 !== d2) {
              validations[invalidAttr] = true
            }
            break
          case group.comparator === '==':
          case group.comparator === '===':
            if (d1 === d2) {
              validations[invalidAttr] = true
            }
            break
        }
      }
    }
    return JSON.stringify(validations) !== JSON.stringify({}) ? validations : null
  }
}

export function multiDatesCheckDiff(groupOfDates: ICompareDatesDiff[]): ValidatorFn {
  return (formGroup: FormGroup<any>): { [key: string]: boolean } | null => {
    const validations: any = {}

    for (let k = 0; k < groupOfDates.length; k++) {
      const group: ICompareDatesDiff = groupOfDates[k]
      const diffInterval: number|null = group.diffCB ? group.diffCB() : group.diff

      if (!diffInterval) {
        continue
      }

      const invalidAttr: string = `invalidDateDiff_${k}`
      const startDate: any = formGroup.get(group.dateStart).value
      const endDate: any = formGroup.get(group.dateEnd).value

      if (startDate && endDate && HelperService.getNoOfDaysBetweenDates(startDate, endDate) > diffInterval * 30) {
        validations[invalidAttr] = true
      }
    }

    return JSON.stringify(validations) !== JSON.stringify({}) ? validations : null
  }
}
